import React from 'react';
import { Input, Message, Button, Form } from '@gasbuddy/react-components';
import $ from 'jquery';
import styles from './styles.css';
import shared from '../../styles/shared.css';

const { api, getSupportEmail, isEmail } = require('../../../lib/bputils').default;

class ForgotPasswordForm extends React.Component {
  state = {
    isLoading: false,
    targetEmail: '',
    emailSent: false,
    hasError: false,
    notValidEmail: false,
  }

  resetPassword = (email) => {
    this.setState({
      isLoading: true,
    });
    const self = this;
    const body = {
      email,
    };
    api.post({
      path: '/users/reset-password',
      data: body,
      error() {
        self.setState({
          isLoading: false,
          hasError: true,
        });
      },
      success() {
        self.setState({
          isLoading: false,
          emailSent: true,
          hasError: false,
        });
        self.hideElements();
      },
    });
  }

  componentDidMount = () => {
    this.autofocusedInput.focus();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ emailSent: false });
    const { targetEmail } = this.state;
    if (isEmail(targetEmail)) {
      this.resetPassword(targetEmail);
    } else {
      this.setState({
        notValidEmail: true,
      });
    }
  }

  handleChange = (e) => {
    this.setState({ notValidEmail: false, targetEmail: e.target.value });
  }

  hideElements = () => {
    $('input').parent().hide();
    $('button').remove();
    $('#formTitle').hide();
    $('#formDetails').hide();
  }

  render() {
    const { isLoading, hasError, notValidEmail, emailSent, targetEmail } = this.state;
    const signInClasses = `${shared.pullLeft} ${shared.blueText} ${styles.signInLink}`;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Input
          label="Enter your email"
          type="email"
          name="email"
          onChange={this.handleChange}
          error={notValidEmail && targetEmail ? 'Please enter a valid email address' : undefined}
          ref={(e) => { this.autofocusedInput = e; }}
        />
        { hasError && targetEmail ? (
          <Message color="red" dismissable>
            {`An error occurred. Please try again or contact support at ${getSupportEmail()}`}
          </Message>
        ) : null }
        { emailSent ? (
          <Message color="teal">
            {`Password Reset Link Sent.  If the account exists, an email has been sent to ${targetEmail} with a link to reset your password.`}
          </Message>
        ) : null }
        <div className={shared.formGroup}>
          <Button
            label="submit"
            disabled={!targetEmail}
            rounded
            color="teal"
            loading={isLoading}
            className={shared.pullRight}
          >
          Request password reset
          </Button>
          <a href="/login.html" rel="noopener noreferrer" className={signInClasses}>{'< Sign in'}</a>
        </div>
      </Form>
    );
  }
}

export default ForgotPasswordForm;
